import authService from './auth/authService';
import agentsService from './agents/agentsService';

const API = {
  authService,
  agentsService,
};

export default API;
